var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
    customTabbar: function () {
      return import(
        /* webpackChunkName: "components/custom-tabbar/custom-tabbar" */ "@/components/custom-tabbar/custom-tabbar.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.showMoney ? (_vm.countData.balance / 100 || 0).toFixed(2) : null
  var g1 = _vm.showMoney
    ? (_vm.countData.pendingAmount / 100 || 0).toFixed(2)
    : null
  var g2 = _vm.showMoney
    ? (_vm.countData.totalWithdrawn / 100 || 0).toFixed(2)
    : null
  var g3 = _vm.showMoney
    ? (_vm.countData.withdrawingAmount / 100 || 0).toFixed(2)
    : null
  var g4 = (_vm.countDataList.totalIncome || 0).toFixed(2)
  var g5 = (_vm.countDataList.totalExpense || 0).toFixed(2)
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.showMoney = !_vm.showMoney
    }
    _vm.e1 = function ($event) {
      _vm.showMoney = !_vm.showMoney
    }
    _vm.e2 = function ($event) {
      _vm.show1 = true
    }
    _vm.e3 = function ($event) {
      _vm.show = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
        g3: g3,
        g4: g4,
        g5: g5,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }